import type { GetRequestOptions, IFetchService } from "app/services/fetchService";

import type { ExtensionGovernanceUsersResponse } from "../../types";

export const GOVERNANCE_BASE_URL = "/sales-api/extension-governance";
const GOVERNANCE_USERS_ENDPOINT = `${GOVERNANCE_BASE_URL}/users`;
const GOVERNANCE_VERSION_ENDPOINT = `${GOVERNANCE_BASE_URL}/extension-version`;

export default function createExtensionManagementApiService(fetchService: IFetchService) {
    return {
        fetchGovernanceUsers(options?: GetRequestOptions): Promise<ExtensionGovernanceUsersResponse> {
            return fetchService.get(GOVERNANCE_USERS_ENDPOINT, undefined, options);
        },
        fetchExtensionVersion(options?: GetRequestOptions): Promise<string> {
            return fetchService.get(GOVERNANCE_VERSION_ENDPOINT, undefined, options);
        },
    };
}
